/**
 * Faturamento
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {FaturamentoCollection} from '@/model/collection/FaturamentoCollection'
import {FaturamentoAgendador} from '@/model/resource/FaturamentoAgendador'
import {FaturamentoConfiguracao} from '@/model/resource/FaturamentoConfiguracao'

export class Faturamento extends Resource {
  idResponsavelFaturamentoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  configDiaInicialDaGeracao: number | null = null
  configDiaFinalDaGeracao: number | null = null
  dataGeracaoFaturamento: string | null = null
  linkGeracaoRelatorio: string | null = null

  @ResponseSerialize(FaturamentoAgendador)
  faturamentoAgendador: FaturamentoAgendador | null = null

  @ResponseSerialize(FaturamentoConfiguracao)
  faturamentoConfiguracao: FaturamentoConfiguracao | null = null

  volumeNotas: number | null = null
  faixaCalculada: string | null = null

  volumeNotasAnterior: number | null = null
  faixaCalculadaAnterior: string | null = null

  get $id() {
    return this.idResponsavelFaturamentoPk
  }
  set $id(val) {
    this.idResponsavelFaturamentoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get getTipoRelatorio(): string {
    return this.faturamentoAgendador === null ||
      this.faturamentoAgendador?.ehAutomatico
      ? 'Automático'
      : 'Manual'
  }

  get getDataInicio() {
    return this.getDayOrCompleteDate(
      this.configDiaInicialDaGeracao || '',
      this.faturamentoAgendador?.paramDataInicio || ''
    )
  }

  get getDataFinal() {
    return this.getDayOrCompleteDate(
      this.configDiaFinalDaGeracao || '',
      this.faturamentoAgendador?.paramDataFim || ''
    )
  }

  private getDayOrCompleteDate(
    dia: Number | '',
    diaCompleto: Date | ''
  ): String {
    if (
      this.faturamentoAgendador === null ||
      this.faturamentoAgendador?.ehAutomatico
    )
      return dia.toString()
    else return Helper.date(diaCompleto)
  }

  /**
   * Lists the instances of Faturamento
   */
  static async listFaturamento(params: any) {
    return await Request.get(`/admin/faturamento`, {params})
      .name('listFaturamento')
      .as(FaturamentoCollection)
      .getData()
  }
  /**
   * Lists the instances of Faturamento to use it in a CSV file
   */
  static async listCsvFaturamento(params: any) {
    return await Request.get(`/admin/faturamento/csv`, {params})
      .name('listCsvFaturamento')
      .as(FaturamentoCollection)
      .getData()
  }

  static async listAvailableYears() {
    return await Request.get(`/admin/faturamento/get-available-years`)
      .name('listAvailableYears')
      .asArrayOf(String)
      .getData()
  }
}
